import $ from 'jquery';

export default {
  init() {

  },
};

